var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{staticClass:"summary-total-chart-container"},[(_vm.isDataLoading)?_c('PreLoaderSection'):_vm._e(),(!_vm.isDataLoading)?_c('LineChart',{attrs:{"series":_vm.series,"categories":_vm.categories,"hide-time":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }